import useDateLocale from 'hooks/useDateLocale/useDateLocale'
import { AppInstallProvider } from './AppInstallProvider'
import AppLicenseProvider from './AppLicenseProvider'
import CheckSubdomainWithTenantProvider from './CheckSubdomainWithTenantProvider'
import { Outlet } from 'react-router-dom'
import { Suspense } from 'react'
import SplashPage from '@pages/SplashPage'
import LicenseExpiredDialog from '@components/LicenseExpiredDialog/LicenseExpiredDialog'
import getEnv from '@utilities/getEnv'
import { IS_SELFHOST_DEPLOYMENT } from '@utilities/deployment'
import SWAppReload from './SWAppReload'
const LOCAL_WITHOUT_PWA = getEnv('LOCAL_WITHOUT_PWA')

export function AppRoot() {
    // Self-host serves every tenant from one origin under /app/:subDomain
    // (path-based tenancy) — a service worker's cache storage/IndexedDB
    // access (see pwa.ts) is origin-scoped, so it would be shared across
    // tenants there. Skip ever attempting registration in self-host, rather
    // than registering and unregistering afterward (see SWAppReload) — that
    // still leaves a window where an installing/activating worker could run
    // pwa.ts's routes against the wrong tenant's data.
    return LOCAL_WITHOUT_PWA || IS_SELFHOST_DEPLOYMENT ? (
        <POSContext />
    ) : (
        <SWAppReload />
    )
}
export function POSContext() {
    useDateLocale()

    return (
        <AppInstallProvider>
            <CheckSubdomainWithTenantProvider>
                <AppLicenseProvider>
                    <Suspense fallback={<SplashPage />}>
                        <Outlet />
                    </Suspense>
                    <LicenseExpiredDialog />
                </AppLicenseProvider>
            </CheckSubdomainWithTenantProvider>
        </AppInstallProvider>
    )
}

export default AppRoot
